import React from 'react';
import { withStyles } from "tss-react/mui";
import MediaQuery from 'react-responsive';
import styles from './styles';

const FooterDivider = props => (
    <MediaQuery maxDeviceWidth={767}>
        {(matches) =>
            <React.Fragment>
                {!matches &&
                    <span className={props.classes.divider}>&nbsp;</span>
                }
            </React.Fragment>
        }
    </MediaQuery>
);

export default withStyles(FooterDivider, styles);